import fetchApi from "../apiHelper";

const API_BASE_URL=process.env.REACT_APP_API_BASE_URL

// Load today's weather by location id
async function httpGetWeatherNowByLocationId(locationId) {

  const response = await fetchApi(`${API_BASE_URL}/weather/` + locationId + `/now`);

  return await response.json();
  }
  
// Load week's weather by location id
async function httpGetWeatherByLocationId(locationId) {

  const response = await fetchApi(`${API_BASE_URL}/weather/` + locationId);

  return await response.json();
}

// Load water level (tide) by station id
async function httpGetWaterLevelByStationId(stationId) {

  const STATION_ID = stationId
  const response = await fetchApi(`${API_BASE_URL}/tide/` + STATION_ID );

  return await response.json();
}

// Load wave forecast by station id
async function httpGetWaveForecastByStationId(stationId) {

  let STATION_ID = stationId

  try {
    //STATION_ID = 46225      // TO-DO remove hardcode, setting station id for the specific spot 
    const response = await fetchApi(`${API_BASE_URL}/forecast/` + STATION_ID );

    //console.log(response)
    return await response.json();
  }
  catch {
    return []
  }
}

// Load wave real time (CDIP) by station id
async function httpGetWaveRealTimeByStationId(stationId) {

  let STATION_ID = stationId

  try {
    //STATION_ID = 46225      // TO-DO remove hardcode, setting station id for the specific spot 
    const response = await fetchApi(`${API_BASE_URL}/forecast/` + STATION_ID + `/realtime` );

    //console.log(response)
    return await response.json();
  }
  catch{
    return []
  }
}
  
export {
    httpGetWaveForecastByStationId,
    httpGetWaveRealTimeByStationId,
    httpGetWaterLevelByStationId,
    httpGetWeatherNowByLocationId,
    httpGetWeatherByLocationId,
  };